

































































































































































































































































































































































































































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  Ref,
  watch,
} from "@vue/composition-api";
import { ArticleRegistrationApi, ArticleRegistrationDto, ProjectDto } from "@/api";
import { formatCurrency } from "@/util/currency";
import {
  toLocalDateStringShort,
  toLocalDateTimeStringShort,
} from "@/util/date";
import i18n from "@/i18n";
import getGender from "@/util/GenderHelper";
import DownloadComponent from "@/components/export/DownloadComponent.vue";
import ResponsiveButton from "@/components/export/ResponsiveButton.vue";
import Store from "@/store";

export default defineComponent({
  setup(props, vm) {
    const articleId = Number(vm.root.$route.params.id);
    const api = new ArticleRegistrationApi();
    const articleDetails: Ref<ArticleRegistrationDto> = ref({});
    const disapproveMessage = ref("");
    const showDialog = ref(false);
    const loading = ref(true);
    const processing = ref(false);
    const showDisapproveDialog = ref(false);

    const disapproveMessageError = ref("");

    const selectedProject = computed<ProjectDto | null>(
      () => Store.getters["User/getSelectedProject"]
    );

    const downloadRequest = () =>
      api.articleRegistrationDownloadArticleRegistrationRequestFile(
        articleId,
        articleDetails.value?.articleRegistrationStatus?.isApproved,
        {
          responseType: "arraybuffer",
        }
      );

    const downloadRequestAao = () =>
      api.articleRegistrationDownloadAaoFile(articleId, {
        responseType: "arraybuffer",
      });

    const editDetail = () =>
      vm.root.$router.push({
        name: "postvak-in-detail-edit",
        params: {
          id: articleDetails.value.articleRegistrationId?.toString() || "",
        },
      });

    async function getArticleDetail() {
      return api
        .articleRegistrationGetArticleRegistration(articleId)
        .then((response) => {
          return response.data;
        });
    }

    function onDisapproveRequest() {
      if (
        disapproveMessage.value === null ||
        disapproveMessage.value === undefined ||
        disapproveMessage.value.length === 0
      ) {
        disapproveMessageError.value = "reden is verplicht.";
      } else {
        showDisapproveDialog.value = true;
      }
    }
    function disapproveRequest() {
      processing.value = true;
      api
        .articleRegistrationDisapproveArticleRegistration({
          articleRegistrationId: articleId,
          reason: disapproveMessage.value || "",
        })
        .then(() => {
          showDisapproveDialog.value = false;
          processing.value = false;
          vm.root.$emit("snackbar", i18n.t("request.disapprove-success"));
          vm.root.$router.push({
            name: "postvak-in",
          });
        })
        .catch(() => {
          processing.value = false;
          vm.root.$emit(
            "snackbar",
            i18n.t("request.disapprove-error"),
            "error"
          );
        });
    }
    function approveRequest() {
      showDialog.value = true;
    }
    function onApproveRequest() {
      processing.value = true;
      api
        .articleRegistrationApproveArticleRegistration({
          articleRegistrationId: articleId,
        })
        .then(() => {
          showDialog.value = false;
          processing.value = false;
          vm.root.$emit("snackbar", i18n.t("request.approve-success"));
          vm.root.$router.push({
            name: "postvak-in",
          });
        })
        .catch(() => {
          showDisapproveDialog.value = false;
          vm.root.$emit("snackbar", i18n.t("request.approve-error"), "error");
        });
    }

    function onUpdateStartDateAndApproveRequest() {
      processing.value = true;
      api
        .articleRegistrationUpdateArticleRegistrationStartDate({
          articleRegistrationId: articleId,
        })
        .then(() => {
          onApproveRequest();
        })
        .catch(() => {
          processing.value = false;
          vm.root.$emit(
            "snackbar",
            i18n.t("request.update-startdate-error"),
            "error"
          );
        });
    }

    onMounted(async () => {
      articleDetails.value = await getArticleDetail();
      loading.value = false;
    });

    watch(selectedProject, () => {
      if (loading.value) return;
      vm.root.$router.push({ name: "dashboard" });
    });

    return {
      articleDetails,
      selectedProject,
      downloadRequest,
      downloadRequestAao,
      disapproveMessage,
      formatCurrency,
      getGender,
      toLocalDateStringShort,
      toLocalDateTimeStringShort,
      onDisapproveRequest,
      onUpdateStartDateAndApproveRequest,
      onApproveRequest,
      showDialog,
      loading,
      processing,
      showDisapproveDialog,
      disapproveRequest,
      disapproveMessageError,
      approveRequest,
      editDetail,
    };
  },
  components: { DownloadComponent, ResponsiveButton },
});
